import Home from '@/pages/Home';
export interface RouteConfig {
    path: string;
    component: React.ComponentType;
    name: string;
    exact?: boolean;
}

export const routes: RouteConfig[] = [
    {
        path: '/',
        component: Home,
        name: 'Home',
        exact: true,
    },
];
